import React from 'react';
import UserTaskDonut from './UserTaskDonut';

type Row = { 
  user_id: number; 
  name: string; 
  profile_picture_url?: string | null;
  pending: number; 
  in_progress: number; 
  completed: number; 
  cancelled: number;
};

type Props = {
  rows: Row[];
};

const TodayTasksDonutCard: React.FC<Props> = ({ rows }) => {
  return (
    <div className="bg-white rounded-lg shadow">
      <div className="px-3 py-2 border-b border-gray-200">
        <h3 className="text-sm font-semibold text-gray-900 text-center leading-tight">Today's Tasks</h3>
      </div>
      
      <div className="px-3 py-2">
        {rows.length === 0 ? (
          <div className="text-xs text-gray-500 text-center">No users in this branch.</div>
        ) : (
          <>
            {/* Horizontal scrollable user donuts */}
            <div className="overflow-x-auto pb-1">
              <div className="flex gap-4 min-w-min justify-center">
                {rows.map((row) => (
                  <div key={row.user_id} className="flex-shrink-0">
                    <UserTaskDonut
                      name={row.name}
                      profilePicture={row.profile_picture_url}
                      pending={row.pending}
                      inProgress={row.in_progress}
                      completed={row.completed}
                      cancelled={row.cancelled}
                    />
                  </div>
                ))}
              </div>
            </div>

            {/* Shared legend - ultra compact */}
            <div className="mt-2 pt-2 border-t border-gray-100 flex flex-wrap items-center justify-center gap-3 text-[11px] leading-4">
              <div className="flex items-center gap-1 text-gray-700">
                <span className="inline-block w-2.5 h-2.5 rounded-full" style={{ backgroundColor: '#22C55E' }}></span>
                <span>completed</span>
              </div>
              <div className="flex items-center gap-1 text-gray-700">
                <span className="inline-block w-2.5 h-2.5 rounded-full" style={{ backgroundColor: '#EF4444' }}></span>
                <span>cancelled</span>
              </div>
              <div className="flex items-center gap-1 text-gray-700">
                <span className="inline-block w-2.5 h-2.5 rounded-full" style={{ backgroundColor: '#FB923C' }}></span>
                <span>pending</span>
              </div>
              <div className="flex items-center gap-1 text-gray-700">
                <span className="inline-block w-2.5 h-2.5 rounded-full" style={{ backgroundColor: '#60A5FA' }}></span>
                <span>in progress</span>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default TodayTasksDonutCard;

